import {
  SiReact,
  SiAngular,
  SiNextdotjs,
  SiJavascript,
  SiTypescript,
  SiApollographql,
  SiSass,
  SiCss3,
  SiGit,
  SiHtml5,
  SiJest,
  SiTestinglibrary,
  SiChakraui,
  SiSpringboot,
  SiStyledcomponents,
  SiRedux,
  SiNodedotjs,
  SiExpress,
  SiVercel,
  SiFirebase,
  SiGithub,
  SiGitlab,
  SiNestjs,
  SiPrettier,
  SiEslint,
  SiShopify,
  SiWebpack,
  SiFramer,
  SiNpm,
  SiYarn,
  SiReactivex,
  SiStorybook,
  SiBitbucket,
  SiWeblate,
  SiJira,
  SiCsharp,
  SiDotnet,
  SiPrisma,
  SiTailwindcss,
  SiMicrosoftsqlserver,
  SiMongodb,
  SiDocker
} from "react-icons/si";

import { DiDotnet } from "react-icons/di";


export const mainSkills = [
  {
    name: "Javascript ES6",
    level: 90,
  },
  {
    name: "React.js",
    level: 90,
  },
  {
    name: "Angular2+",
    level: 85,
  },
  {
    name: "Next.js",
    level: 85,
  },
  {
    name: "Design",
    level: 80,
  },
  {
    name: "Testing",
    level: 80,
  },
  {
    name: "Code Review",
    level: 95,
  },
  {
    name: "Typescript",
    level: 85,
  },
];

export const skills = [
  { name: "React.js", Icon: SiReact },
  { name: "Next.js", Icon: SiNextdotjs },
  { name: "Redux", Icon: SiRedux },
  { name: "Prisma", Icon: SiPrisma },
  { name: "CSharp", Icon: SiCsharp},
  { name: ".NET", Icon: DiDotnet},
  // { name: "RxJS/NgRx", Icon: SiReactivex },
  // { name: "Apollo GraphQL", Icon: SiApollographql },
  { name: "Javascript", Icon: SiJavascript },
  { name: "Typescript", Icon: SiTypescript },
  { name: "HTML5", Icon: SiHtml5 },
  { name: "CSS3", Icon: SiCss3 },
  { name: "Tailwind", Icon: SiTailwindcss },
  { name: "Sass", Icon: SiSass },
  // { name: "Framer", Icon: SiFramer },
  // { name: "EsLint", Icon: SiEslint },
  { name: "Prettier", Icon: SiPrettier },
  { name: "Styled-components", Icon: SiStyledcomponents },
  // { name: "Storybook", Icon: SiStorybook },
  { name: "Chakra UI", Icon: SiChakraui },
  { name: "Jest", Icon: SiJest },
  { name: "Testing Library", Icon: SiTestinglibrary },
  { name: "Node.js", Icon: SiNodedotjs },
  { name: "Git", Icon: SiGit },
  { name: "GitHub", Icon: SiGithub },
  { name: "GitLab", Icon: SiGitlab },
  // { name: "Bitbucket", Icon: SiBitbucket },
  // { name: "Weblate", Icon: SiWeblate },
  // { name: "Jira", Icon: SiJira },
  { name: "Npm", Icon: SiNpm },
  { name: "Yarn", Icon: SiYarn },
  { name: "Vercel", Icon: SiVercel },
  { name: "Webpack", Icon: SiWebpack, dabbled: true },
  { name: "Express.js", Icon: SiExpress, dabbled: true },
  { name: "Sql Server", Icon: SiMicrosoftsqlserver, },
  { name: "docker", Icon: SiDocker },
  // { name: "NestJS", Icon: SiNestjs, dabbled: true },
];
